import { component } from "picoapp";
import choozy from "choozy";
import { add, remove, on, qs, qsa, toggle } from "@selfaware/martha";
import { gsap } from "gsap/all";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default component((node, ctx) => {
  let { image, scroller } = choozy(node);

  let arrows = qsa('.js-arrow', node)

  const handleArrows = (state) => {
    arrows.forEach((arrow, index) => {
      if(state <= index){
        remove(arrow, 'opacity-0')
      } else{
        add(arrow, 'opacity-0')
      }
    })
  }

  on(scroller, 'click', () => {
    gsap.to(window, {
      duration: 1.5,
      scrollTo: {
        y: image.offsetHeight,
        offsetY: 0,
      },
      ease: 'expo.out',
    })
  })

  const handleScroll = () => {
    let distance = window.scrollY || window.pageYOffset;
    let viewport = document.documentElement.clientHeight;
    let hero = image.offsetHeight;
    let totalHeight = distance + viewport;

    let percentScrolled = distance / hero

    if(document.documentElement.clientWidth >= 900){
      node.style.height = `${hero}px`;
    } else{
      node.style.height = null
    }

    if (totalHeight >= hero) {
      remove(node, "lock");
    } else {
      add(node, "lock");

      if(document.documentElement.clientWidth >= 900){
        image.style.transform = `translateY(-${distance}px)`
      } else{
        image.style.transform = null
      }
    }

    if(percentScrolled > .16 && percentScrolled <= .32){
      handleArrows(1)
    } else if(percentScrolled > .32 && percentScrolled <= .48){
      handleArrows(2)
    } else if(percentScrolled > .48 && percentScrolled <= .64){
      handleArrows(3)
    } else if(percentScrolled > .64 && percentScrolled <= .80){
      handleArrows(4)
    } else if(percentScrolled > .80){
      handleArrows(5)
    } else{
      handleArrows(0)
    }
  };

  on(window, 'resize', () => {
    let hero = image.offsetHeight;
    node.style.height = `${hero}px`;

    if(document.documentElement.clientWidth >= 900){
      node.style.height = `${hero}px`;
    } else{
      node.style.height = null
    }
  })

  handleScroll();
  on(window, "scroll", () => handleScroll());

  return () => {
    off(window, "scroll", handleScroll());
  };
});
